<template>
    <div class="login-content-qbox">
        <div class="login-content-qbox-1">
            <span class="login-content-qbox-1-s" @click="goBack">返回</span>
            <img class="login-content-qbox-1-i" src="../img/qcode.png" alt="扫描二维码">
            <p class="login-content-qbox-1-p">请使用管理员微信扫描图中二维码登录</p>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
      goBack () {
        this.$router.back()
      }
    }
}
</script>

<style lang="scss" scoped>
    .login-content-qbox {
      width: 384px;
      height: 425px;
      position: absolute;
      right: 19.5%;
      bottom: 30%;
      display: flex;
      align-items: center;
      justify-content: center;
      &-1 {
        width: 360px;
        height: 400px;
        background-color: #fff;
        box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
        border-radius: 2px;
        position: relative;
        display: flex;
        flex-direction: column;
        &-s {
          font-size: 18px;
          color: #4c4c4c;
          margin: 28px 0 0 296px;
          cursor: pointer;
        }
        &-i {
          width: 231px;
          height: 231px;
          margin: 27px 0 0 64px;
        }
        &-p {
          font-size: 18px;
          color: #333;
          margin: 35px 0 0 28px;
        }
      }
    }
</style>